<script>
import SLAPopoverCard from 'dashboard/components/widgets/conversation/components/SLAPopoverCard.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    SLAPopoverCard,
    NextButton,
  },
  props: {
    slaEvents: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      showSlaPopoverCard: false,
    };
  },

  methods: {
    closeSlaEvents() {
      this.showSlaPopoverCard = false;
    },
    openSlaEvents() {
      this.showSlaPopoverCard = !this.showSlaPopoverCard;
    },
  },
};
</script>

<template>
  <div
    v-on-clickaway="closeSlaEvents"
    class="col-span-2 flex items-center justify-end text-auth-muted dark:text-auth-muted-dark"
  >
    <div class="relative">
      <NextButton
        link
        slate
        type="button"
        :label="$t('SLA_REPORTS.TABLE.VIEW_DETAILS')"
        class="!text-auth-action dark:!text-auth-accent"
        @click="openSlaEvents"
      />
      <SLAPopoverCard
        v-if="showSlaPopoverCard"
        :sla-missed-events="slaEvents"
        class="right-0"
      />
    </div>
  </div>
</template>
